import { get } from "@visactor/vutils";

export const getter = path => obj => get(obj, path);
//# sourceMappingURL=getter.js.map